<template>
    <div class="c-order-select pointer">
        <select class="c-order-select__native-select" v-if="isMobile" name="" id="" v-model="nativeSelectValue">
          <option v-for="(item, i) of orderList" :key="i" :value="i">{{item.title}}</option>
        </select>
        <div v-if="iconMbStyle && isMobile" class="c-order-select__mb-selected">
            <div>{{orderText}}</div>
            <img src="@/assets/img/icon/arrow_down_gray.svg"/>
        </div>
        <div v-else-if="pcOptionH && !isMobile" class="c-order-select__option-h h-align">
            <div class="c-order-select__option-h-item" v-for="(item, index) in orderList" :key="index" :data-id="item.value" @click="clickEvent(index)" :class="{'c-order-select__option-h-item--active': item.value == orderList[selected].value}">{{item.title}}</div>
        </div>
        <div v-else class="c-order-select__header h-align" :class="{'c-order-select__header--active': isOpen}" @click="isOpen = !isOpen">
            {{orderText}}：{{orderList[selected].title}}
            <div class="c-order-select__triangle" :class="{'c-order-select__triangle--active': isOpen}"></div>
        </div>
        <div v-show="isOpen" class="c-order-select__body block-xs-radius">
            <div class="c-order-select__item" v-for="(item, index) in orderList" :key="index" :data-id="item.value" @click="clickEvent(index)">{{item.title}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isOpen: false,
            selected: 0,
            isMobile: null,
            nativeSelectValue: null,
        }
    },
    props: {
        value: null,
        orderList: {
            type: Array,
            default: ()=>{
                return [
                    {
                        title: '水',
                        value: 'WATER'
                    },
                    {
                        title: '電',
                        value: 'ELECTRICT'
                    },
                    {
                        title: '瓦斯',
                        value: 'GAS'
                    },
                ]
            }
        },
        orderText: {
            type: String,
            default: '拍表紀錄',
        },
        defaultSelected: {
            type: String,
            default: null,
        },
        routeUpdate: {
            type: Boolean,
            default: true,
        },
        iconMbStyle: {
            type: Boolean,
            default: false,
        },
        pcOptionH: {
            type: Boolean,
            default: false,
        },
    },
    mounted () {
        if(this.getDeviceSystem() === 'pc'){
            this.isMobile = false
        }else{
            this.isMobile = true
        }
        // 點擊select以外 關閉select
        document.addEventListener("click",e => {
            if(!this.$el.contains(e.target)){
            // 以外:關閉
            this.isOpen = false;
            }
        })
    },
    watch: {
        nativeSelectValue (val) {
            this.selected = val
            // if(this.routeUpdate){
            //     this.setOrderParams(this.orderList[this.selected].value)
            // }
            this.$emit('input', this.orderList[this.selected].value)
        },
        value: {
            handler: function (val){
                setTimeout(()=>{
                    // console.log('32e3e',val)
                    let orderList = this.orderList
                    for (let i = 0; i < orderList.length; i++) {
                        const element = orderList[i];
                        // console.log('element',element.value)
                        // console.log('val',val)
                        // console.log(element.value === val)
                        // console.log('i',i)
                        if(element.value === val){
                            this.selected = i
                            break
                        }else{
                            this.selected = 0
                        }
                    }
                }, 200)
            },
            deep: true,
            immediate: true
        },
        defaultSelected: {
            handler: function (val){
                if(val) {
                    let orderList = this.orderList
                    for (let i = 0; i < orderList.length; i++) {
                        const element = orderList[i];
                        if(element.value === val){
                            this.selected = i
                            break
                        }else{
                            this.selected = 0
                        }
                    }
                }
            },
            immediate: true
        },
    },
    methods: {
        clickEvent(index) {
            this.selected = index
            this.isOpen = false
            // if(this.routeUpdate){
            //     this.setOrderParams(this.orderList[this.selected].value)
            // }
            this.$emit('input', this.orderList[this.selected].value)
        },
        setOrderParams(value){
            let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 深拷贝
            newQuery.sort = value
            this.$router.replace({ query: newQuery }).catch(err => {err})
        }
    },
}
</script>
<style lang="scss" scoped>
    .c-order-select{
        position: relative;
        font-size: 14px;
        cursor: pointer;
        &__native-select{
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 1;
        }
        &__header{
            &:hover{
                color: #ff9275;
                .c-order-select__triangle{
                    border-color: #ff9275 transparent transparent transparent;
                }
            }
            &--active{
                color: #ff9275;
            }
        }
        &__triangle{
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 6px 4px 0 4px;
            border-color: #ccc transparent transparent transparent;
            margin-left: 6px;
            &--active{
                border-width: 0 4px 6px 4px;
                border-color: transparent transparent #ff9275 transparent;
            }
        }
        &__body{
            position: absolute;
            width: 160px;
            top: 26px;
            right: 0;
            border-radius: 4px;
            background: #f3f3f3;
            padding: 4px 0;
            z-index: 2;
        }
        &__item{
            padding: 13px 14px;
            color: #292625;
            &:hover{
                background: #fff;
                color: #292625;
            }
        }
        &__mb-selected {
            display: flex;
            align-items: center;
            img {
                margin-left: 4px;
            }
        }
        &__option-h {

        }
        &__option-h-item {
            cursor: pointer;
            font-size: 16px;
            margin-left: 20px;
            &--active {
            color: #000;
            font-weight: 500;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/widges/input/selectRecord.vue